import {Directive} from '@angular/core';

@Directive({
  selector: 'textarea[msTextarea]',
  exportAs: 'msTextarea',
  standalone: true,
})
export class TextareaDirective {}
